import clsx from "clsx";
import {useFetchCategories} from "../hooks/useFetchCategories.ts";
import HeartIcon from "../assets/images/icons/icon-heart.png";
import "../scss/user-selected-category.scss";

type Props = {
  userSelectedCategories: string[];
  setUserSelectedCategories: (categories: string[]) => void;
}
const   UserSelectedCategoriesView: React.FC<Props> = ({userSelectedCategories, setUserSelectedCategories}) => {
  const {data: categories} = useFetchCategories(false);

  const handleCategoryClick = (categoryId: string) => {
    if (userSelectedCategories.includes(categoryId)) {
      setUserSelectedCategories(userSelectedCategories.filter(id => id !== categoryId));
      return;
    }
    setUserSelectedCategories([...userSelectedCategories, categoryId]);
  };

  return (
    <section className="mb-5 user-selected-categories">
      <p className="font-yettel-bold">Omiljene kategorije</p>
      <div className="categories-content">
        {categories?.map((category) => {
          return (<div key={category.id} className={clsx(userSelectedCategories.includes(category.id) && 'category-item--active' ,"category-item")} onClick={() => handleCategoryClick(category.id)}>
            <div className="me-1 d-inline-block">
              <p className="font-yettel m-0 d-inline-block">
                {userSelectedCategories.includes(category.id) ? <img src={HeartIcon} width={13} alt="heart"/> : '+ '}
              </p>
              <span className="ms-1 d-inline-block">

                {category.name}
              </span>
            </div>
          </div>)
        })}
      </div>
    </section>
  )
}

export default UserSelectedCategoriesView;
